import type { TalentTree } from '../../CharacterTypes';

export const WARRIOR_TALENTS: TalentTree = {
    'combat': [
      {
        id: 'warrior_strength',
        name: 'Strength Training',
        description: 'Increase strength by 2 per rank',
        icon: '/icons/warrior_strength.svg',
        maxRank: 5,
        currentRank: 0,
        cost: 1,
        prerequisites: [],
        effects: [
          { type: 'stat_bonus', target: 'strength', value: 2, perRank: true }
        ]
      },
      {
        id: 'warrior_endurance',
        name: 'Endurance Training',
        description: 'Increase endurance by 2 per rank',
        icon: '/icons/warrior_endurance.svg',
        maxRank: 5,
        currentRank: 0,
        cost: 1,
        prerequisites: ['warrior_strength'],
        effects: [
          { type: 'stat_bonus', target: 'endurance', value: 2, perRank: true }
        ]
      },
      {
        id: 'warrior_critical',
        name: 'Critical Strike',
        description: 'Increase critical chance by 1% per rank',
        icon: '/icons/warrior_critical.svg',
        maxRank: 5,
        currentRank: 0,
        cost: 2,
        prerequisites: ['warrior_strength'],
        effects: [
          { type: 'stat_bonus', target: 'criticalChance', value: 0.01, perRank: true }
        ]
      },
      {
        id: 'warrior_heavy_blows',
        name: 'Heavy Blows',
        description: 'Increase strength by 4 per rank',
        icon: '/icons/warrior_strength.svg',
        maxRank: 5,
        currentRank: 0,
        cost: 2,
        prerequisites: ['warrior_critical'],
        effects: [
          { type: 'stat_bonus', target: 'strength', value: 4, perRank: true }
        ]
      },
      {
        id: 'warrior_colossus',
        name: 'Colossus',
        description: 'Increase maximum health by 60 per rank',
        icon: '/icons/warrior_endurance.svg',
        maxRank: 5,
        currentRank: 0,
        cost: 2,
        prerequisites: ['warrior_endurance'],
        effects: [
          { type: 'stat_bonus', target: 'maxHp', value: 60, perRank: true }
        ]
      },
      {
        id: 'warrior_battle_mastery',
        name: 'Battle Mastery',
        description: 'Increase critical chance by 2.5% per rank',
        icon: '/icons/warrior_critical.svg',
        maxRank: 5,
        currentRank: 0,
        cost: 3,
        prerequisites: ['warrior_heavy_blows'],
        effects: [
          { type: 'stat_bonus', target: 'criticalChance', value: 0.025, perRank: true }
        ]
      }
    ],
    'defense': [
      {
        id: 'warrior_defense',
        name: 'Defense Training',
        description: 'Increase defense by 3 per rank',
        icon: '/icons/warrior_defense.svg',
        maxRank: 5,
        currentRank: 0,
        cost: 1,
        prerequisites: [],
        effects: [
          { type: 'stat_bonus', target: 'defense', value: 3, perRank: true }
        ]
      },
      {
        id: 'warrior_iron_skin',
        name: 'Iron Skin',
        description: 'Increase defense by 5 per rank',
        icon: '/icons/warrior_defense.svg',
        maxRank: 5,
        currentRank: 0,
        cost: 2,
        prerequisites: ['warrior_defense'],
        effects: [
          { type: 'stat_bonus', target: 'defense', value: 5, perRank: true }
        ]
      },
      {
        id: 'warrior_shield_wall',
        name: 'Shield Wall',
        description: 'Increase magic defense by 4 per rank',
        icon: '/icons/warrior_defense.svg',
        maxRank: 5,
        currentRank: 0,
        cost: 2,
        prerequisites: ['warrior_defense'],
        effects: [
          { type: 'stat_bonus', target: 'magicDefense', value: 4, perRank: true }
        ]
      },
      {
        id: 'warrior_juggernaut',
        name: 'Juggernaut',
        description: 'Increase maximum health by 80 per rank',
        icon: '/icons/warrior_endurance.svg',
        maxRank: 5,
        currentRank: 0,
        cost: 3,
        prerequisites: ['warrior_iron_skin'],
        effects: [
          { type: 'stat_bonus', target: 'maxHp', value: 80, perRank: true }
        ]
      }
    ]
};

export const HUNTER_TALENTS: TalentTree = {
    'agility': [
      {
        id: 'ranger_agility',
        name: 'Agility Training',
        description: 'Increase agility by 4 per rank',
        icon: '/icons/ranger_agility.svg',
        maxRank: 5,
        currentRank: 0,
        cost: 1,
        prerequisites: [],
        effects: [
          { type: 'stat_bonus', target: 'agility', value: 4, perRank: true }
        ]
      },
      {
        id: 'ranger_critical',
        name: 'Precision',
        description: 'Increase critical chance by 2% per rank',
        icon: '/icons/ranger_critical.svg',
        maxRank: 5,
        currentRank: 0,
        cost: 2,
        prerequisites: ['ranger_agility'],
        effects: [
          { type: 'stat_bonus', target: 'criticalChance', value: 0.02, perRank: true }
        ]
      },
      {
        id: 'ranger_pathfinding',
        name: 'Pathfinding',
        description: 'Increase defense by 3 per rank',
        icon: '/icons/ranger_agility.svg',
        maxRank: 5,
        currentRank: 0,
        cost: 1,
        prerequisites: ['ranger_agility'],
        effects: [
          { type: 'stat_bonus', target: 'defense', value: 3, perRank: true }
        ]
      },
      {
        id: 'ranger_keen_eye',
        name: 'Keen Eye',
        description: 'Increase critical chance by 3% per rank',
        icon: '/icons/ranger_critical.svg',
        maxRank: 5,
        currentRank: 0,
        cost: 2,
        prerequisites: ['ranger_critical'],
        effects: [
          { type: 'stat_bonus', target: 'criticalChance', value: 0.03, perRank: true }
        ]
      },
      {
        id: 'ranger_wild_heart',
        name: 'Wild Heart',
        description: 'Increase maximum health by 50 per rank',
        icon: '/icons/ranger_agility.svg',
        maxRank: 5,
        currentRank: 0,
        cost: 2,
        prerequisites: ['ranger_pathfinding'],
        effects: [
          { type: 'stat_bonus', target: 'maxHp', value: 50, perRank: true }
        ]
      },
      {
        id: 'ranger_sniper',
        name: 'Eagle Eye',
        description: 'Increase agility by 6 per rank',
        icon: '/icons/ranger_critical.svg',
        maxRank: 5,
        currentRank: 0,
        cost: 3,
        prerequisites: ['ranger_keen_eye'],
        effects: [
          { type: 'stat_bonus', target: 'agility', value: 6, perRank: true }
        ]
      }
    ]
};

export const ROGUE_TALENTS: TalentTree = {
    'shadow': [
      {
        id: 'assassin_agility',
        name: 'Agility Training',
        description: 'Increase agility by 4 per rank',
        icon: '/icons/assassin_agility.svg',
        maxRank: 5,
        currentRank: 0,
        cost: 1,
        prerequisites: [],
        effects: [
          { type: 'stat_bonus', target: 'agility', value: 4, perRank: true }
        ]
      },
      {
        id: 'assassin_luck',
        name: "Thief's Luck",
        description: 'Increase critical chance by 2.5% per rank',
        icon: '/icons/assassin_luck.svg',
        maxRank: 5,
        currentRank: 0,
        cost: 2,
        prerequisites: ['assassin_agility'],
        effects: [
          { type: 'stat_bonus', target: 'criticalChance', value: 0.025, perRank: true }
        ]
      },
      {
        id: 'assassin_shadow_focus',
        name: 'Shadow Focus',
        description: 'Increase defense by 3 per rank',
        icon: '/icons/assassin_agility.svg',
        maxRank: 5,
        currentRank: 0,
        cost: 1,
        prerequisites: ['assassin_agility'],
        effects: [
          { type: 'stat_bonus', target: 'defense', value: 3, perRank: true }
        ]
      },
      {
        id: 'assassin_lethal_precision',
        name: 'Lethal Precision',
        description: 'Increase agility by 6 per rank',
        icon: '/icons/assassin_luck.svg',
        maxRank: 5,
        currentRank: 0,
        cost: 2,
        prerequisites: ['assassin_luck'],
        effects: [
          { type: 'stat_bonus', target: 'agility', value: 6, perRank: true }
        ]
      },
      {
        id: 'assassin_shadow_vigor',
        name: 'Shadow Vigor',
        description: 'Increase maximum health by 40 per rank',
        icon: '/icons/assassin_agility.svg',
        maxRank: 5,
        currentRank: 0,
        cost: 2,
        prerequisites: ['assassin_shadow_focus'],
        effects: [
          { type: 'stat_bonus', target: 'maxHp', value: 40, perRank: true }
        ]
      },
      {
        id: 'assassin_vital_strikes',
        name: 'Vital Strikes',
        description: 'Increase critical chance by 3% per rank',
        icon: '/icons/assassin_luck.svg',
        maxRank: 5,
        currentRank: 0,
        cost: 3,
        prerequisites: ['assassin_lethal_precision'],
        effects: [
          { type: 'stat_bonus', target: 'criticalChance', value: 0.03, perRank: true }
        ]
      },
      {
        id: 'assassin_evasion_mastery',
        name: 'Evasion Mastery',
        description: 'Increase magic defense by 5 per rank',
        icon: '/icons/assassin_agility.svg',
        maxRank: 5,
        currentRank: 0,
        cost: 2,
        prerequisites: ['assassin_shadow_vigor'],
        effects: [
          { type: 'stat_bonus', target: 'magicDefense', value: 5, perRank: true }
        ]
      }
    ]
};
